// extracted by mini-css-extract-plugin
export var bound = "index-module--bound--a0da3";
export var list = "index-module--list--56d30";